import { setEditing } from '../../../State/editing'

export default () => (dispatch) => {

  dispatch(setEditing(true))

}
